<div
  class="stepper-wrapper"
  [ngClass]="{ 'completed': isCompleted() }">

  <div
    *ngFor="let step of steps"
    class="stepper-item"
    [ngClass]="detectStepClass(step.number)"
    [attr.style]="step.inlineStyle | safestyle">
    <div class="step-counter"></div>
    <div class="step-name" [ngStyle]="transferOfControl ? {'text-transform': 'none'} : null" [innerHTML]="step.name"></div>
  </div>
</div>
